import React from 'react';

import { Container as MaterialContainer } from '@sunwisesoftware/sunwise-ui';
import { useTranslation } from 'react-i18next';

import { HeaderContainer, TitleIcon } from 'common/components';

import funnelFinancing from '../funnelFinancing';

const Funnel = () => {
    const { t } = useTranslation();
    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <TitleIcon title={t('Financing funnel')} />
            </HeaderContainer>

            <funnelFinancing.Container />
        </MaterialContainer>
    );
};

export default Funnel;
